import React, {useEffect} from "react";
import {getMallWithSubDomain} from "../../Services";
import {CheckinData} from "../Scan/ScanServices";
import {useHistory, useLocation,} from "react-router";
import {useDispatchMall} from "../../hooks";
import "./Dispatcher.scss";

function Dispatcher(){

    const location = useLocation();
    const history = useHistory();
    const setMall = useDispatchMall();

    useEffect(()=>{
        console.log("Loc : ",location)
        dispatchProcess()
    },[])

    const getMall = async (sub)=>{
        try {
            return  await getMallWithSubDomain(sub);
        }
        catch (e) {
            console.log(e)
        }
    }


    const dispatchProcess = async ()=>{
        //detect sub or main link
        let full = window.location.hostname;
        let parts = full.split('.');

        let sub = "";
        let isAdmin = "";

        if(parts.length===3 && parts[0]!=="www"){
            sub = parts[0]
        }else{
            sub = "app"
        }

         isAdmin = parts[0];

        if(isAdmin==="www" || isAdmin==="test")
            isAdmin = parts[1];

        if(isAdmin==="digimaall" || isAdmin==="test" || isAdmin==="stage" || isAdmin==="localhost" || isAdmin==="apluss"  || isAdmin==="app" ){
            let temp = isAdmin;

            isAdmin = "digimaall";
            if(temp==="app" && parts[1] !== "apluss"){
                isAdmin = "app"
                console.log("in")
            }
            // if(temp==="app" && parts[1] !== "digimaall"){
            //     isAdmin = "app"
            //     console.log("out")
            // }
        }

        console.log("Sub domain dispatcher : ",sub,isAdmin)

        let token = localStorage.getItem("token");

        if(isAdmin!=="digimaall"){
            //if sub -> set sub mall and redirect to home
            console.log("aaaaaaaaaaaaaaaaa dispatcher")
            let malli = await getMall(sub)
            console.log("Mall : ",malli)
            malli = malli.data;
            // await CheckinData("mc_"+malli.uid)
            localStorage.setItem('mallId',malli.uid);
            localStorage.setItem('mallLogo',malli.header_image);
            localStorage.setItem('mallWhite',malli.logo);
            localStorage.setItem('mallName',malli.name);
            localStorage.setItem('mall',JSON.stringify(malli));

            localStorage.setItem('theme',JSON.stringify({
                primary:malli.primary_color?.color,
                secondary:malli.secondary_color?.color,
                tertiary:malli.tertiary_color?.color
            }));


            setMall(malli);
            history.push('/home')
        }else {
            console.log("bbbbbbbbbbbbbbb dispatcher")
            //if main ->set default mall and redirect to home
            if(token){
                console.log("ccccccccccccccc dispatcher")
                history.push('/home')
            }else{
                console.log("dddddddddddddddddd dispatcher")
                // let obj = {
                //     about_us:null,
                //     cover:"https://test-loyalty-minio.darkube.app/loyalty-media/campaign/campaign/images/%D9%84%D9%88%DA%AF%D9%882_aGZiK3h.png",
                //     created:"2022-11-09T09:58:50.540431+03:30",
                //     description:"",
                //     enable:true,
                //     english_name:"demolab",
                //     header_image:"https://test-loyalty-minio.darkube.app/loyalty-media/mall/mall/header_images/%D9%84%D9%88%DA%AF%D9%881_A9Y942X.jpg",
                //     image:"https://test-loyalty-minio.darkube.app/loyalty-media/campaign/campaign/images/%D9%84%D9%88%DA%AF%D9%882_CCvdhvR.png",
                //     is_chain_store:false,
                //     is_featured:false,
                //     logo:"https://test-loyalty-minio.darkube.app/loyalty-media/mall/mall/logos/%D9%84%D9%88%DA%AF%D9%882_ZWbjp6z.png",
                //     name:"آزمایشگاه دمو",
                //     notification_message:"",
                //     order:1,
                //     payment_sdk_client_id:null,
                //     phone:null,
                //     show_map:false,
                //     thumbnail:"https://test-loyalty-minio.darkube.app/loyalty-media/campaign/campaign/images/%D9%84%D9%88%DA%AF%D9%882_8j4wXOp.png",
                //     uid:"MxaeJ3UvbW",
                // }
                // localStorage.setItem('mallId','MxaeJ3UvbW');
                // localStorage.setItem('mallLogo',"https://test-loyalty-minio.darkube.app/loyalty-media/mall/mall/header_images/%D9%84%D9%88%DA%AF%D9%881_A9Y942X.jpg");
                // localStorage.setItem('mallName',"آزمایشگاه دمو");
                // localStorage.setItem('mall',JSON.stringify(obj));
                // setMall(obj);
                history.push('/login')
            }

        }

    }

    return(
        <div className="dispatcher-loading">
            <img src="/svg/pre.gif" alt=""/>
        </div>
    )
}
export default Dispatcher;
